import { CardCarouselButton } from '@time-line/components/common';
import { ArrowRight } from '@time-line/components/icons';

interface ProductReviewMediaCarouselButtonProps {
  direction: 'next' | 'prev';
  size?: number;
  variant?: 'outline' | 'white';
}

export function ProductReviewMediaCarouselButton({
  direction,
  size = 68,
  variant = 'outline',
}: ProductReviewMediaCarouselButtonProps) {
  return (
    <CardCarouselButton
      variant={variant}
      direction={direction}
      position="absolute"
      boxSize={`${size}px`}
      zIndex={1}
      right={direction === 'next' ? 'sm' : 'auto'}
      left={direction === 'prev' ? 'sm' : 'auto'}
    >
      <ArrowRight
        boxSize={`${size / 1.7}px`}
        transform={direction === 'prev' ? 'scaleX(-1)' : 'auto'}
      />
    </CardCarouselButton>
  );
}
